export enum AlertRuleFilterType {
  ISSUE_OLDER_THAN = 'ISSUE_OLDER_THAN',
  ISSUE_NEWER_THAN = 'ISSUE_NEWER_THAN',

  ATTRIBUTE_FILTER = 'ATTRIBUTE_FILTER',
}
